import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import store  from '@/store'
import {whiteList, whiteNames} from './config/whitelist'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { TokenModel } from '@/config/tokenModel.ts'


const getQueryString = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  if (window.location.href.indexOf('?') < 0) {
    return null
  }
  const r = window.location.href.split('?')[1].match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}
let query_token = getQueryString('token')
let site_code = getQueryString('site_code')
if(query_token) {
  store.dispatch('setToken', query_token)
}
if(site_code) {
  store.dispatch('setSiteCode', site_code)
  localStorage.setItem('code', site_code)
}
NProgress.configure({ showSpinner: false })
if(!store.getters.token && localStorage.getItem(TokenModel.token_name)) store.dispatch('setToken', localStorage.getItem(TokenModel.token_name))
if (!store.getters.user_info && localStorage.getItem(TokenModel.user_info)) store.dispatch('setUserInfo', JSON.parse(localStorage.getItem(TokenModel.user_info)))
if (!store.getters.store_info && localStorage.getItem(TokenModel.store_info)) store.dispatch('setStoreInfo', JSON.parse(localStorage.getItem(TokenModel.store_info)))

router.beforeEach(async(to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  NProgress.start()
  if (store.getters.token) {
    to.query.lang && store.dispatch('setLanguages', to.query.lang)
    if (to.path === '/login') {
      // If is logged in, redirect to the home page
      next({
        path: '/'
      })
      NProgress.done()
    } else {
      // Check user has permission roles
    //   if (store.state.user.roles.length === 0) {
    //   } else {
    //     next()
    //   }
      next()
    }
  } else {
    const whitePath = whiteList.some(path => path === to.path)
    const whiteRouteName = whiteNames.some(name => name === to.name)
    // 是否属于登录白名单route
    if (whitePath || whiteRouteName) {
      to.query.lang && store.dispatch('setLanguages', to.query.lang)
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to: RouteLocationNormalized) => {
    NProgress.done()
})
